import { Observable } from './zenObservable';
export * from './zenObservable';
export default Observable;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/zen-observable-ts/lib/index.js
// module id = 110
// module chunks = 0